var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      class: [{ open: _vm.open }, "service"],
      on: {
        click: function($event) {
          $event.stopPropagation()
          return _vm.openService.apply(null, arguments)
        }
      }
    },
    [
      !_vm.loading
        ? _c("div", { staticClass: "product" }, [
            _c("div", { staticClass: "title" }, [
              _c(
                "span",
                {
                  staticClass: "name",
                  attrs: { title: _vm.service.product.name }
                },
                [
                  _c("div", { staticClass: "status" }, [
                    _vm.service.status === "unset" ||
                    _vm.service.status === "deletable"
                      ? _c(
                          "div",
                          { staticClass: "ui horizontal label small" },
                          [
                            _vm._v(
                              _vm._s(_vm.$t("components.service.status.unset"))
                            )
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.service.status === "active"
                      ? _c(
                          "div",
                          { staticClass: "ui horizontal green label small" },
                          [
                            _vm._v(
                              _vm._s(_vm.$t("components.service.status.active"))
                            )
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.service.status === "inactive"
                      ? _c(
                          "div",
                          { staticClass: "ui horizontal red label small" },
                          [
                            _vm._v(
                              _vm._s(
                                _vm.$t("components.service.status.inactive")
                              )
                            )
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.service.status === "overdue"
                      ? _c(
                          "div",
                          { staticClass: "ui horizontal red label small" },
                          [
                            _vm._v(
                              _vm._s(
                                _vm.$t("components.service.status.overdue")
                              )
                            )
                          ]
                        )
                      : _vm._e()
                  ]),
                  _vm._v(" "),
                  _c("span", [
                    _vm._v(
                      "\n\t\t\t\t\t\t" +
                        _vm._s(_vm.shortString(_vm.service.product.name, 46)) +
                        "\n\t\t\t\t\t"
                    )
                  ])
                ]
              ),
              _vm._v(" "),
              _c("div", { staticClass: "meta" }, [
                _c("span", { staticClass: "next-date" }, [
                  _vm._v(
                    "\n\t\t\t\t\t\t" +
                      _vm._s(_vm.$t("components.service.payment_date")) +
                      " " +
                      _vm._s(_vm.formatDate(_vm.service.transaction_date)) +
                      "\n\t\t\t\t\t"
                  )
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "right" }, [
                _vm.service.status === "unset" ||
                _vm.service.status === "deletable"
                  ? _c(
                      "button",
                      {
                        staticClass: "ui blue circular mini button",
                        on: {
                          click: function($event) {
                            $event.stopPropagation()
                            return _vm.openService.apply(null, arguments)
                          }
                        }
                      },
                      [
                        _vm._v(
                          "\n\t\t\t\t\t\t" +
                            _vm._s(_vm.$t("globals.buttons.finish")) +
                            "\n\t\t\t\t\t"
                        )
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "ui circular mini button absolute-button",
                    class: { blue: _vm.service.status === "active" },
                    on: {
                      click: function($event) {
                        $event.stopPropagation()
                        return _vm.openService.apply(null, arguments)
                      }
                    }
                  },
                  [
                    _vm._v(
                      "\n\t\t\t\t\t\t" +
                        _vm._s(
                          _vm.open
                            ? _vm.$t("globals.buttons.close")
                            : _vm.$t("globals.buttons.open")
                        ) +
                        "\n\t\t\t\t\t"
                    )
                  ]
                ),
                _vm._v(" "),
                _vm.waitlistid && _vm.canChangePaymentMethod
                  ? _c(
                      "button",
                      {
                        staticClass: "ui circular mini button",
                        on: {
                          click: function($event) {
                            $event.preventDefault()
                            _vm.updatePaymentModal = !_vm.updatePaymentModal
                          }
                        }
                      },
                      [
                        _vm._v(
                          "\n            " +
                            _vm._s(_vm.$t("globals.buttons.change_card")) +
                            "\n          "
                        )
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.canBeCancelled
                  ? _c(
                      "button",
                      {
                        staticClass: "ui circular grey mini button",
                        on: {
                          click: function($event) {
                            $event.preventDefault()
                            _vm.cancelServiceModal = !_vm.cancelServiceModal
                          }
                        }
                      },
                      [
                        _vm._v(
                          "\n\t\t\t\t\t\t" +
                            _vm._s(_vm.$t("globals.buttons.cancel")) +
                            "\n\t\t\t\t\t"
                        )
                      ]
                    )
                  : _vm._e()
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "info" }, [
              _c("span", { staticClass: "interval" }, [
                _c("span", { staticClass: "metatitle" }, [
                  _vm._v(_vm._s(_vm.$t("components.service.payment_type")))
                ]),
                _vm._v(" "),
                _vm.service.pricing
                  ? _c("span", [
                      _vm.service.pricing.type === "recurring"
                        ? _c("i", { staticClass: "refresh icon" })
                        : _vm.service.pricing.type === "instant"
                        ? _c("i", { staticClass: "money bill alternate icon" })
                        : _vm._e(),
                      _vm._v(
                        "\n\t\t\t\t\t\t" + _vm._s(_vm.interval) + "\n\t\t\t\t\t"
                      )
                    ])
                  : _c("span", [
                      _vm._v(
                        "\n\t\t\t\t\t\t" +
                          _vm._s(_vm.$t("components.service.unset")) +
                          "\n\t\t\t\t\t"
                      )
                    ])
              ]),
              _vm._v(" "),
              _c("span", { staticClass: "payment" }, [
                _c("span", { staticClass: "metatitle" }, [
                  _vm._v(_vm._s(_vm.$t("components.service.payment_method")))
                ]),
                _vm._v(" "),
                _vm.cardDigits
                  ? _c("span", {
                      domProps: { innerHTML: _vm._s(_vm.getCardIcon) }
                    })
                  : _vm.service.payment_method === "mobile_pay"
                  ? _c("span", [_vm._v("Mobile Pay")])
                  : _vm.service.payment_method === "vipps"
                  ? _c("span", [_vm._v("Vipps")])
                  : _c("span", [
                      _vm._v(
                        "\n\t\t\t\t\t\t" +
                          _vm._s(_vm.$t("components.service.unset")) +
                          "\n\t\t\t\t\t"
                      )
                    ])
              ]),
              _vm._v(" "),
              _c("span", { staticClass: "price" }, [
                _c("span", { staticClass: "metatitle" }, [
                  _vm._v(_vm._s(_vm.$t("components.service.price")))
                ]),
                _vm._v(
                  "\n\t\t\t\t\t" +
                    _vm._s(_vm.formatPrice(_vm.service.pricing_amount)) +
                    "\n\t\t\t\t"
                )
              ])
            ])
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("semantic-loading", {
        attrs: { active: _vm.loading, text: _vm.$t("globals.loaders.loading") }
      }),
      _vm._v(" "),
      _c("new-waitlist-modal", {
        attrs: { subscription: _vm.service, active: _vm.showSubscriptionModal },
        on: { refreshsubscription: _vm.refreshService }
      }),
      _vm._v(" "),
      _c(
        "modal",
        {
          ref: "modal",
          attrs: {
            active: _vm.cancelServiceModal,
            icons: "big payment",
            title: _vm.$t("globals.validation.warnings.are_you_sure"),
            popout: true
          },
          on: {
            acceptmodal: function($event) {
              return _vm.cancelService()
            },
            denymodal: function($event) {
              return _vm.declineCancelService()
            }
          }
        },
        [
          _c("h4", [
            _vm._v(
              _vm._s(_vm.$t("components.service.validation.cancel_service"))
            )
          ]),
          _vm._v(" "),
          _c("div", { attrs: { slot: "box-actions" }, slot: "box-actions" }, [
            _c(
              "div",
              {
                staticClass: "ui red basic circular button",
                on: {
                  click: function($event) {
                    return _vm.$refs.modal.denyModal()
                  }
                }
              },
              [_vm._v(_vm._s(_vm.$t("globals.buttons.no")))]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "ui blue circular button",
                on: {
                  click: function($event) {
                    return _vm.$refs.modal.acceptModal()
                  }
                }
              },
              [_vm._v(_vm._s(_vm.$t("globals.buttons.yes")))]
            )
          ])
        ]
      ),
      _vm._v(" "),
      _c(
        "modal",
        {
          ref: "payment_update_modal",
          attrs: {
            active: _vm.updatePaymentModal,
            icons: "big payment",
            title: _vm.$t("globals.validation.warnings.are_you_sure"),
            popout: true
          },
          on: {
            acceptmodal: function($event) {
              return _vm.updatePaymentInformation()
            },
            denymodal: function($event) {
              return _vm.closePaymentModal()
            }
          }
        },
        [
          _c("h4", [
            _vm._v(
              _vm._s(
                _vm.$t(
                  "components.service.validation.update_payment_information"
                )
              )
            )
          ]),
          _vm._v(" "),
          _c("div", { attrs: { slot: "box-actions" }, slot: "box-actions" }, [
            _c(
              "div",
              {
                staticClass: "ui red basic circular button",
                on: {
                  click: function($event) {
                    return _vm.$refs.payment_update_modal.denyModal()
                  }
                }
              },
              [_vm._v(_vm._s(_vm.$t("globals.buttons.no")))]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "ui blue circular button",
                on: {
                  click: function($event) {
                    return _vm.$refs.payment_update_modal.acceptModal()
                  }
                }
              },
              [_vm._v(_vm._s(_vm.$t("globals.buttons.yes")))]
            )
          ])
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-75995633", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-75995633","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/subscription/Service.vue
// module id = 6Kx7
// module chunks = 1